import React from "react";
import "./styles.css";

const Hero = () => {
  return (
    <div className="hero">
      <h1 className="hero__title">Franco Melcon</h1>
      <p className="hero__text">Front End Developer</p>
    </div>
  );
};

export default Hero;
